import { useMemo } from "react";
import { WORK_HISTORY } from "../constants";
import { getMonthDifference } from "../utils/getMonthDifference";

import "./Company.css";
import styled from "styled-components";
import Position, { PositionProps } from "./Position";
import { HEIGHT_BUFFER } from "../constants/styles";

const CompanyWrapper = styled.div<{ height: number; primaryColor: string }>`
  height: ${({ height }) => height}px;

  .company__time-indicator {
    background-color: ${({ primaryColor }) => primaryColor};
  }
  .company__time-indicator::before {
    border-bottom: 5px solid ${({ primaryColor }) => primaryColor};
  }
  .company__time-indicator::after {
    border-left: 5px solid ${({ primaryColor }) => primaryColor};
    border-right: 5px solid ${({ primaryColor }) => primaryColor};
  }
`;

interface CompanyProps extends Omit<PositionProps, "position" | "companyName"> {
  company: (typeof WORK_HISTORY)[0];
}

export default function Company({ company, setExpandedPosition, expandedPosition }: CompanyProps) {
  const from = company.positions[0].to;
  const to = company.positions[company.positions.length - 1].from;

  const height = useMemo(() => {
    return getMonthDifference(to, from) * HEIGHT_BUFFER;
  }, [to, from]);

  return (
    <CompanyWrapper
      height={height}
      primaryColor={company.primaryColor}
      className="company"
    >
      <div className="company__time-indicator" />
      {company.positions.map((position, index) => (
        <Position
          companyName={company.company}
          position={position}
          key={index}
          setExpandedPosition={setExpandedPosition}
          expandedPosition={expandedPosition} />
      ))}
    </CompanyWrapper>
  );
}
